<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-06-13 14:48:09
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-13 18:50:46
 * @FilePath: /partner.chaoyongtuan.com/src/modules/sample/apply/rules/batchButton.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
  <span>
    <el-button @click="batch">批量修改申样门槛</el-button>
  </span>
</template>
<script>
export default {
  name: 'batchEditApplySampleConditionButton',
  props: {
    selectedArr: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    batch() {
      if(!this.selectedArr.length) {
        this.$message.warning('请先选择商品');
        return;
      }
      this.$Bus.$emit('show', {mode: 'batch', goods: this.selectedArr});
    }
  }
}
</script>